import { useFormikContext } from "formik";

const CheckBoxQuestions = ({ name, label }) => {
  const { values, setFieldValue } = useFormikContext();

  const handleSelect = (value) => {
    setFieldValue(name, value);
  };

  return (
    <div className="symptom-question">
      <span className="symptom-text">{label}</span>
      <div className="yes-no-checkboxes">
        {["Yes", "No"].map((option) => {
          const isYes = option === "Yes";
          const isSelected =
            (isYes && values[name] === true) ||
            (!isYes && values[name] === false);

          return (
            <label key={option} className="checkbox-option">
              <input
                type="checkbox"
                className="checkbox-input"
                checked={isSelected}
                onChange={() => handleSelect(isYes ? true : false)}
              />
              <span className="option-text">{option}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default CheckBoxQuestions;
